import styled from 'styled-components';
import { theme, whenFocused } from '@frameio/vapor';
import {
  Border,
  Chevron,
  InnerContainer,
  itemColorStates,
} from './ItemContainer';

type BaseContainerProps = {
  $isActive: boolean;
};

export const BaseContainer = styled.div<BaseContainerProps>`
  outline: none;

  ${whenFocused} {
    ${InnerContainer} {
      background: ${itemColorStates.default};

      ${Chevron} {
        opacity: 0.5;
      }

      ${Border} {
        border: solid 1px ${theme.colors.border.interactive.focused};
      }
      ${(p) => !p.$isActive && 'opacity: 1;'}
    }
  }
`;
